// CLASSES
import AppConfig from "@classes/AppConfig";

export default function(props, state)
{
    if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
    {
        return true;
    }

    const {fields, validFields} = state;

    for (const name in validFields)
    {
        if (validFields[name] === false)
        {
            return false;
        }
    }

    /**
     * Is this tjänstepension needs to be selected
     */
    if (!optionsListValueSelected(fields.checkbox_accounttype))
    {
        return false;
    }


    /**
     * Hur stor andel av förmögenheten needs to be selected
     */
    if (!optionsListValueSelected(fields.checkbox_advice_invpercentage))
    {
        return false;
    }

    /**
     * How was the meeting conducted needs to be selected
     */
    if (!optionsListValueSelected(fields.futur_insured_kyc_meeting_form))
    {
        return false;
    }

    /**
     * Purpose for opening an account needs to be selected
     */
    if (!optionsListValueSelected(fields.futur_insured_kyc_purpose))
    {
        return false;
    }

    /**
     * If selected other purpose we need to fill out the text field
     */
    if (fields.futur_insured_kyc_purpose.options[3].checked && fields.futur_insured_kyc_purpose_other.length === 0)
    {
        return false;
    }

    /**
     * Inital deposit to the account needs to be selected
     */
    if (!optionsListValueSelected(fields.futur_insured_kyc_initial_premium))
    {
        return false;
    }

    /**
     * If selected other initial deposit we need to fill out the text field
     */
    if (fields.futur_insured_kyc_initial_premium.options[5].checked &&
        (fields.futur_insured_kyc_initial_premium_other.length === 0 ||
            fields.futur_insured_kyc_initial_premium_other <= 10000000))
    {
        return false;
    }

    /**
     * Inital deposit to the account needs to be selected
     */
    if (!optionsListValueSelected(fields.futur_insured_kyc_yearly_premium))
    {
        return false;
    }

    /**
     * If selected other initial deposit we need to fill out the text field
     */
    if (fields.futur_insured_kyc_yearly_premium.options[6].checked &&
        (fields.futur_insured_kyc_yearly_premium_other.length === 0 ||
            fields.futur_insured_kyc_yearly_premium_other <= 10000000))
    {
        return false;
    }

    if (fields.advice_allocation_motivation_risc.length === 0)
    {
        return false;
    }

    if (fields.advice_customer_financial_suitability.length === 0)
    {
        return false;
    }

    if (fields.customer_aml_origin.length === 0)
    {
        return false;
    }

    if (fields.advice_customer_suitability_knowledge.length === 0)
    {
        return false;
    }

    if (fields.advice_notes.length === 0)
    {
        return false;
    }

    return true;
}

function optionsListValueSelected(optionsList)
{
    const options = optionsList.options;
    for (let i = 0; i < options.length; i++)
    {
        if (options[i].checked)
        {
            return true;
        }
    }
    return false;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/InsuredKyc/Fair/InsuredKyc.fulfillment.js